import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  id?: string;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, disabled = false, label, id }) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substring(7)}`;

  return (
    <div className={`toggle-wrapper ${disabled ? 'toggle-disabled' : ''}`}>
      <button
        id={toggleId}
        type="button"
        role="switch"
        aria-checked={checked}
        className={`toggle-switch ${checked ? 'toggle-switch--on' : ''}`}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
      >
        <span className="toggle-switch__thumb" />
      </button>
      {label && (
        <label htmlFor={toggleId} className="toggle-label">
          {label}
        </label>
      )}
    </div>
  );
};

export default Toggle;
